import "core-js/stable";
import "regenerator-runtime/runtime";

import "./js/config.js";
// Load in vendor scripts (loaded by Webpack directly);
import "bootstrap";

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Load in styles
import "./scss/styles.scss";

import validationService from './js/validationService';
import addressFinder from './js/addressFinder';

validationService();

const addressFinders = document.querySelectorAll('.js-find-address');

if (addressFinders.length) {
    addressFinders.forEach((x) => {
        addressFinder(x);
    })
}

const orderProcessing = document.querySelector('.js-order-processing');

if (orderProcessing) {
    setInterval(() => {
        fetch(`/Umbraco/Surface/OrderStatus/Get/?id=${orderProcessing.dataset.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response => {
                if (!response.processing) {
                    window.location = response.url
                }
                else {
                    document.querySelector('.js-processing-message').innerHTML = response.message;
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, 2000);
}


// Conditional dynamic imports

// Webpack will store those modules in separate JS files and
// load them on demand, keeping payload down.


// Load in custom JS modules required on initial page load

import(
    /* webpackFetchPriority: "high" */
    './js/viewport-size'
);

if (document.querySelector('body.site-layout') != null) {
    import('./js/scrolling');
    import('./js/keyboard-accessibility-check');
}

if (document.querySelector('.header--content--menu') != null) {
    import('./js/main-navigation');
}

if (document.querySelector('#header--content--search--show--btn') != null) {
    import('./js/header-search');
}

if (document.querySelector('#checkout-time-remaining') != null) {
    import('./js/checkout-time-remaining');
}

if (document.querySelector('#emergency-message') != null) {
    import('./js/alert-message');
}

if (document.querySelector('#checkout-time-remaining') != null) {
    import('./js/checkout-time-remaining');
}

if (document.querySelector('#header--utility-bar--basket') != null) {
    import('./js/header-basket-indicator');
}


// Load in custom JS modules on initial page load and when DOM is updated

const addDataJsParsed = (elements, tag = '') => {
    elements.forEach(x => {
        x.setAttribute(`data-js-parsed--${tag}`,'');
    });
}

const quickCheckQueries = [];
let quickCheckQueryComplete = false,
    quickCheckQueryString = null;
const addQuickCheckQuery = (s) => {
    if(!quickCheckQueryComplete) {
        quickCheckQueries.push(s);
        quickCheckQueryString = quickCheckQueries.toString();
    }
};
const jsModuleQuickCheck = async () => {
    let checkQuery = document.querySelector(quickCheckQueryString);
    if (checkQuery != null) jsModuleCheck();
};

const jsModuleCheck = async () => {

    let testQueryString = null,
        testQuery = null;

    // accordion open/close all
    testQueryString = '.accordion--open-close-all:not([data-js-parsed--accordion-open-close-all])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "accordion-open-close-all");
        import('./js/accordion-open-close-all').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // smart-bootstrap-tabs
    testQueryString = '.nav[role="tablist"]:not([data-js-parsed--smart-bootstrap-tabs])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "smart-bootstrap-tabs");
        import('./js/smart-bootstrap-tabs').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // collapse - expand for desktop
    testQueryString = '.expand-for-desktop:not([data-js-parsed--expand-for-desktop])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "expand-for-desktop");
        import('./js/collapse-expand-for-desktop').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // list-carousel
    testQueryString = '.list-carousel:not([data-js-parsed--list-carousel])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "list-carousel");
        import('./js/list-carousel').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // non-lazyload img-load-watcher
    testQueryString = 'img.img-load-watcher:not([data-js-parsed--img-load-watcher])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "img-load-watcher");
        import('./js/img-load-watcher').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hero video - vimeo
    testQueryString = '.hero--video.vimeo:not([data-js-parsed--vimeo])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "vimeo");
        import(
            /* webpackFetchPriority: "high" */
            './js/hero-video-vimeo'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hero video - youtube
    testQueryString = '.hero--video.youtube:not([data-js-parsed--youtube])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "youtube");
        import(
            /* webpackFetchPriority: "high" */
            './js/hero-video-youtube'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // defer-iframe-content
    testQueryString = 'iframe.defer-iframe-content[data-src]:not([data-js-parsed--defer-iframe-content])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "defer-iframe-content");
        import(
            /* webpackMode: "lazy" */
            './js/defer-iframe-content'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // height matching
    testQueryString = '*[data-hm-group]:not([data-js-parsed--height-match])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "height-match");
        import('./js/height-match').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hunt-watch
    testQueryString = '.hunt-watch:not([data-js-parsed--hunt-watch])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "hunt-watch");
        import('./js/hunt-watch').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // section--scroll-reveal
    testQueryString = '.section--scroll-reveal:not([data-js-parsed--section--scroll-reveal])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "section--scroll-reveal");
        import('./modules/section-scroll-reveal/section-scroll-reveal.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // lightboxes (PhotoSwipe v5 - galleries and single images)
    testQueryString = '.lightbox-image:not([data-js-parsed--lightbox]), .image-gallery:not([data-js-parsed--lightbox])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "lightbox");
        import(
            /* webpackMode: "lazy" */
            './modules/lightboxes-galleries/lightboxes.js'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // fixed-bg-video
    testQueryString = '.fixed-bg-video:not([data-js-parsed--fixed-bg-video])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fixed-bg-video")
        import('./js/fixed-bg-video').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // responsive nav bar
    testQueryString = '.responsive-nav-bar:not([data-js-parsed--responsive-nav-bar])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "responsive-nav-bar");
        import('./modules/responsive-nav-bar/responsive-nav-bar.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // responsive table
    testQueryString = '.responsive-table:not([data-js-parsed--responsive-table])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "responsive-table");
        import('./modules/responsive-table/responsive-table.js');
    }

    // width-watcher
    testQueryString = '*[data-width-watcher]:not([data-js-parsed--width-watcher])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "width-watcher");
        import('./js/width-watcher').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // panels-swiper
    testQueryString = '.panels-swiper:not([data-js-parsed--panels-swiper])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "panels-swiper");
        import('./js/panels-swiper').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // basic-swiper
    testQueryString = '.basic-swiper:not([data-js-parsed--basic-swiper])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "basic-swiper");
        import('./js/basic-swiper').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // testimonials-carousel
    testQueryString = '.testimonials-carousel:not([data-js-parsed--testimonials-carousel])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "testimonials-carousel");
        import('./modules/testimonials-carousel/testimonials-carousel.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // filter-listing (live and static)
    testQueryString = '.filter-listing:not([data-js-parsed--filter-listing])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "filter-listing");
        import('./modules/filter-listing/filter-listing.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // help search form
    testQueryString = '.help-search-form:not([data-js-parsed--help-search-form])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "help-search-form");
        import(
            /* webpackMode: "lazy" */
            './js/help-search-form'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // media-gallery
    testQueryString = '.media-gallery:not([data-js-parsed--media-gallery])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "media-gallery");
        import('./modules/media-gallery/media-gallery.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // opening times calendar
    testQueryString = '.opening-times:not([data-js-parsed--calendar])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "calendar");
        import('./modules/opening-times-calendar/opening-times-calendar').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }
        
    // tripadvisor icon shiv
    testQueryString = '.fa-tripadvisor:not([data-js-parsed--fa-tripadvisor])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fa-tripadvisor");
        import(
            /* webpackMode: "lazy" */
            './js/tripadvisor-icon-shiv'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }
    
    // tiktok icon shiv
    testQueryString = '.fa-tiktok:not([data-js-parsed--fa-tiktok])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fa-tiktok");
        import(
            /* webpackMode: "lazy" */
            './js/tiktok-icon-shiv'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // ***** ecommerce stuff *****

    // add-to-basket
    testQueryString = '.add-to-basket[data-product-id]:not([data-js-parsed--add-to-basket])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "add-to-basket");
        import('./js/add-to-basket').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // form number control
    testQueryString = '.form-number-control:not(.readonly):not([data-js-parsed--form-number-control])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "form-number-control");
        import('./js/form-number-control').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // quantity selector - family tickets
    testQueryString = '.visitors-quantity-selector--visitor-type.family-ticket:not([data-js-parsed--family-ticket])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "family-ticket");
        import('./js/visitor-quantity-selector--family-tickets').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    testQueryString = '.calendar-booking:not([data-js-parsed--calendar-booking])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "calendar-booking");
        if (thisDomQuery.length) {
            import('./js/calendarBookingApi').then(({ default: CalendarBookingApi }) => {
                thisDomQuery.forEach(calendarBookingElement => {
                    new CalendarBookingApi(calendarBookingElement);
                });
            });
        }
    }

    //const calendarBookingElements = document.querySelectorAll('.js-calendar-booking');

    //if (calendarBookingElements.length) {
    //    import('./js/calendarBookingApi').then(({ default: CalendarBookingApi }) => {
    //        calendarBookingElements.forEach(calendarBookingElement => {
    //            new CalendarBookingApi(calendarBookingElement);
    //        });
    //    });
    //}

    // radio-collapse-control
    testQueryString = '.radio-collapse-control:not([data-js-parsed--radio-collapse-control])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "radio-collapse-control");
        import('./js/radio-collapse-control').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // checkout extras (modals)
    testQuery = document.querySelector('.checkout--extras-listing--item[data-extras-product-id]:not([data-js-parsed--checkout-extras])');
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll('.checkout--extras-listing--item[data-extras-product-id]:not([data-js-parsed--checkout-extras])');
        addDataJsParsed(thisDomQuery, "checkout-extras");
        import('./js/checkout-extras').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }
};


//// create a mutation observer to watch for dynamically added HTML

let checkRequested = false, checkTimeout = null;

// run a check on page load
jsModuleCheck();

// Select the node that will be observed for mutations
const targetNode = document.querySelector('body');
if(targetNode != null) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
        // Use traditional 'for loops' for IE 11
        let checkNeeded = false;
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                checkNeeded = true;
            }
        }
        if(checkNeeded && !checkRequested) {
            checkRequested = true;
            clearTimeout(checkTimeout);
            checkTimeout = setTimeout(() => {
                jsModuleQuickCheck();
                checkRequested = false;
            }, 100);
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    setTimeout(() => {
        // do another check now
        jsModuleQuickCheck();
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }, 3000);
}